__turbopack_context__.v({
  "closeButton": "NativeVideo-module-scss-module__GvINhG__closeButton",
  "modal": "NativeVideo-module-scss-module__GvINhG__modal",
  "modalContainer": "NativeVideo-module-scss-module__GvINhG__modalContainer",
  "modalVideoWrapper": "NativeVideo-module-scss-module__GvINhG__modalVideoWrapper",
  "overlay": "NativeVideo-module-scss-module__GvINhG__overlay",
  "playButton": "NativeVideo-module-scss-module__GvINhG__playButton",
  "playButtonIcon": "NativeVideo-module-scss-module__GvINhG__playButtonIcon",
  "root": "NativeVideo-module-scss-module__GvINhG__root",
});
